import PubSub from "underpub-js";
import gsap from 'gsap';

var CallToAction = function (options) {

  this.options = {
    $el: false,
    baseClass: 'mol-CallToAction',
    isToggled: false,
  };

  $.extend(true, this.options, options);

};

CallToAction.prototype.init = function () {

  var self = this;

  self.$inner = self.options.$el.find(`.${self.options.baseClass}__inner`);
  self.$button = self.options.$el.find(`.${self.options.baseClass}__button`);
  self.$form = self.options.$el.find(`.${self.options.baseClass}__form`);
  self.$secondary = self.options.$el.find(`.${self.options.baseClass}__secondary`);
  self.$buttonClose = self.options.$el.find(`.${self.options.baseClass}__button-close`);

  if (self.$form.length && self.$button.length && self.$secondary.length) {
    self.initAnimation();
    self.$button.on('click', () => self.toggleOn());
    self.$buttonClose.on('click', () => self.toggleOff());
  }
};

CallToAction.prototype.initAnimation = function () {
  const self = this;

  self.$primary = self.options.$el.find(`.${self.options.baseClass}__primary`);
  self.$primaryInner = self.options.$el.find(`.${self.options.baseClass}__primary__inner`);
  self.$secondaryInner = self.options.$el.find(`.${self.options.baseClass}__secondary__inner`);

  const getPrimaryHeightTween = () =>
    gsap.to(self.$primary, {
      height: self.options.isToggled ? 'auto' : 0,
      duration: 0.3,
      ease: 'expo.inout',
    });

  const getSecondaryHeightTween = () =>
    gsap.to(self.$secondary, {
      height: self.options.isToggled ? 0 : 'auto',
      duration: 0.3,
      ease: 'expo.inout',
    });

  const getPrimaryInnerTween = () =>
    gsap.to(self.$primaryInner, {
      opacity: self.options.isToggled ? 1 : 0,
      delay: self.options.isToggled ? .2 : 0,
      duration: 0.3,
      ease: 'expo.inout',
    });

  self.timeline = gsap
    .timeline({
      paused: true,
      reversed: true,
      onComplete: () => {
        self.toggleState();
        gsap.to(window, {
          scrollTo: {
            y: self.$inner[0],
            offsetY: 10
          },
          duration: .5,
          ease: 'expo.inout',
        })
      },
      onReverseComplete: () => self.toggleState(),
      defaults: {
        duration: 0.3,
        ease: 'expo.inout',
      }
    })
    .call(getPrimaryInnerTween)
    .call(getPrimaryHeightTween, null, ">")
    .call(getSecondaryHeightTween, null, '<')
    .fromTo(
      self.$secondaryInner, {
        opacity: 0,
      }, {
        opacity: 1,
      },
      '<.2',
    )
    .from(self.$buttonClose, {
      opacity: 0,
      y: 20,
    }, "<");
};

CallToAction.prototype.toggleState = function () {
  const self = this;

  self.options.isToggled = !self.options.isToggled;
};

CallToAction.prototype.toggleOn = function (speed = 1) {
  const self = this;

  if (self.options.isToggled || self.timeline.isActive()) return;

  self.timeline.timeScale(speed).play();
};

CallToAction.prototype.toggleOff = function (speed = 3) {
  const self = this;

  if (!self.options.isToggled || self.timeline.isActive()) return;

  self.timeline.timeScale(speed).reverse();
};

CallToAction.prototype.toggle = function () {
  const self = this;

  self.timeline.reversed() ? self.toggleOn() : self.toggleOff();
};

export default CallToAction;